const ConditionClasses = ["car",
                          "carRelated",
                          "car-warranty",
                          "home",
                          "home-warranty",
                          "roommate",
                          "furniture",
                          "career",
                          "college",
                          "careerRelated",
                          "job",
                          "manager",
                          "game",
                          "cash",
                          "boat",
                          "recreationVehicle",
                          "horse"
                    ]
      

export default ConditionClasses;